module.exports = __webpack_public_path__ + "static/23-mural1-f72d31f350c636bc0073937d0d82ac47.jpg";